import * as ActionCable from '@rails/actioncable';
import { createConsumer } from '@rails/actioncable';

ActionCable.logger.enabled = false
export default window.websockets ? createConsumer('/cable') : null
